import type { SectionId, PartId, ChoiceId, TestData } from '../types/testy';

// Simple validation functions without Zod for now
const validSectionIds: SectionId[] = ['clovek-a-spolecnost', 'stat-a-pravo', 'hospodarstvi-a-svet'];
const validPartIds: PartId[] = [
  'psychologie', 'sociologie', 'filozofie',
  'ustavni-pravo', 'obcanske-pravo', 'trestni-pravo',
  'ekonomie', 'geografie', 'dejiny'
];
const validChoiceIds: ChoiceId[] = ['A', 'B', 'C', 'D'];

// Validation functions (currently unused but kept for future use)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isValidSectionId(id: any): id is SectionId {
  return validSectionIds.includes(id);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isValidPartId(id: any): id is PartId {
  return validPartIds.includes(id);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isValidChoiceId(id: any): id is ChoiceId {
  return validChoiceIds.includes(id);
}

// Simple validation functions for TestData
function validateTestDataStructure(data: any): { success: boolean; data?: TestData; errors?: string[] } {
  const errors: string[] = [];
  
  if (!data || typeof data !== 'object') {
    return { success: false, errors: ['Invalid data format'] };
  }
  
  // Basic validation
  if (!data.id || typeof data.id !== 'string') {
    errors.push('Test ID is required');
  }
  
  if (!data.title || typeof data.title !== 'string') {
    errors.push('Test title is required');
  }
  
  if (!data.durationSec || typeof data.durationSec !== 'number' || data.durationSec <= 0) {
    errors.push('Valid test duration is required');
  }
  
  if (data.feedbackMode !== 'end_only') {
    errors.push('Feedback mode must be "end_only"');
  }
  
  if (!Array.isArray(data.sections) || data.sections.length !== 3) {
    errors.push('Test must have exactly 3 sections');
  }
  
  if (typeof data.isPublished !== 'boolean') {
    errors.push('isPublished must be a boolean');
  }
  
  if (typeof data.isFreeSample !== 'boolean') {
    errors.push('isFreeSample must be a boolean');
  }
  
  if (errors.length > 0) {
    return { success: false, errors };
  }
  
  return { success: true, data: data as TestData };
}

// Export validation functions
export function validateTestData(data: unknown): { success: boolean; data?: TestData; error?: { issues: Array<{ message: string; path: string[] }> } } {
  const result = validateTestDataStructure(data);
  
  if (!result.success) {
    return {
      success: false,
      error: {
        issues: (result.errors || []).map(message => ({ message, path: [] }))
      }
    };
  }
  
  return { success: true, data: result.data };
}

export function validateTestAttempt(data: unknown): any {
  // Simple validation for now
  return { success: true, data };
}

// Utility function to get detailed validation errors
export function getValidationErrors(result: any): string[] {
  if (result.success) return [];
  
  if (result.error && result.error.issues) {
    return result.error.issues.map((issue: any) => {
      const path = issue.path && issue.path.length > 0 ? `${issue.path.join('.')}: ` : '';
      return `${path}${issue.message}`;
    });
  }
  
  return ['Validation failed'];
}